import { ITelemetryBaseLogger } from '@fluidframework/common-definitions';
import { ThemeColorPropertyNames } from '@fluidx/component-ux';
import { verifyContrastRatioThresholds, sendErrorEvent } from '@fluidx/utilities';

export async function validateThemingAccessibility(
  stylingProperties?: { [propertyName: string]: string },
  logger?: ITelemetryBaseLogger
): Promise<void> {
  if (!stylingProperties || !logger) {
    return;
  }

  const contrastRatioEntries = [
    {
      color1: stylingProperties[ThemeColorPropertyNames.MenuBackground],
      color1Label: ThemeColorPropertyNames.MenuBackground,
      color2: stylingProperties[ThemeColorPropertyNames.MenuItemText],
      color2Label: ThemeColorPropertyNames.MenuItemText,
      threshold: 4.5
    },
    {
      color1: stylingProperties[ThemeColorPropertyNames.MenuBackground],
      color1Label: ThemeColorPropertyNames.MenuBackground,
      color2: stylingProperties[ThemeColorPropertyNames.InputBackgroundChecked],
      color2Label: ThemeColorPropertyNames.InputBackgroundChecked,
      threshold: 3
    }
  ];

  const errors = verifyContrastRatioThresholds(contrastRatioEntries);
  if (errors.length > 0) {
    sendErrorEvent(logger, { eventName: 'ThemingAccessibility' }, { message: JSON.stringify(errors) });
  }
}
